<template>
  <div class="box is-shadowless">
    <div class="columns">
      <div class="column is-4 is-offset-4">
        <div class="card">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <p class="title is-4">FORGOT PASSWORD</p>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <b-button class="is-invisible"></b-button>
                </div>
              </div>
            </div>
            <b-message
              type="is-success"
              size="is-small"
              :active.sync="success"
              has-icon
            >If your account is in good standing you can expect a password reset email promptly.</b-message>
            <form @submit.prevent="onSubmit">
              <b-field label="Email">
                <b-input v-model="form.email" type="email"></b-input>
              </b-field>
              <div class="level">
                <div class="level-left"></div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <div class="control">
                        <button
                          :class="
                            `button is-dark ${loading ? 'is-loading' : ''}`
                          "
                        >SUBMIT</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from "@/services/auth.service";

export default {
  props: {
    email: {
      type: String
    }
  },
  data: () => ({
    authService: AuthService,
    form: {
      email: ""
    },
    success: false,
    loading: false
  }),
  mounted() {
    this.form.email = this.email || "";
  },
  methods: {
    async onSubmit() {
      this.loading = true;

      try {
        await this.authService.forgotPassword({
          email_address: this.form.email
        });
        this.success = true;
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/PasswordForgot/index.vue